module.exports = __webpack_public_path__ + "img/E1 DP2.3cf888b3.png";